module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.token) ? _c('div', [_c('loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('page-title', {
    attrs: {
      "title": "Editar Token"
    }
  }, [_c('div', {
    staticClass: "btnGroup",
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': !_vm.statusToken
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(false)
      }
    }
  }, [_vm._v("\n        Inativo\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--info btn--outline",
    class: {
      'is-active': _vm.statusToken
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus(true)
      }
    }
  }, [_vm._v("\n        Ativo\n      ")])])]), _vm._v(" "), _c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Token",
      "columns": 4
    }
  }, [_c('div', {
    staticClass: "margin"
  }, [_vm._v("\n          " + _vm._s(_vm.token.authorization) + "\n          "), _c('button', {
    directives: [{
      name: "clipboard",
      rawName: "v-clipboard:copy",
      value: (_vm.token.authorization),
      expression: "token.authorization",
      arg: "copy"
    }],
    staticClass: "btn btn--sm btn--info copy hint hint--top",
    attrs: {
      "type": "button",
      "data-label": "Clique para copiar token"
    },
    on: {
      "click": function($event) {
        return _vm.copied()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-copy2"
  })])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nome",
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.token.description),
      expression: "token.description"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.token.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.token, "description", $event.target.value)
      }
    }
  })])], 1)]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Permissões de produto"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "",
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionProductSelected),
      expression: "permissionProductSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.permissionProductSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getPermissionProduct()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "notPermission"
    }
  }, [_vm._v("Sem permissão")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "readOnly"
    }
  }, [_vm._v("Somente leitura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "readAndWriting"
    }
  }, [_vm._v("Leitura e escrita")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "advancedOptionsProduct"
    }
  }, [_vm._v("Opções avançadas")])])])], 1), _vm._v(" "), (_vm.permissionProductSelected === 'advancedOptionsProduct') ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.productAdvancedOptions), function(option) {
    return _c('form-group', {
      key: option,
      attrs: {
        "label": option.resource,
        "columns": 4
      }
    }, _vm._l((Object.keys(option.actions)), function(action) {
      return _c('label', {
        staticClass: "form-checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (option.actions[action]),
          expression: "option.actions[action]"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(option.actions[action]) ? _vm._i(option.actions[action], null) > -1 : (option.actions[action])
        },
        on: {
          "change": function($event) {
            var $$a = option.actions[action],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(option.actions, action, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(option.actions, action, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(option.actions, action, $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "form-checkbox__indicator"
      }), _vm._v(" "), _c('span', {
        staticClass: "form-checkbox__text"
      }, [_vm._v(_vm._s(action))])])
    }), 0)
  }), 1)]) : _vm._e()]), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Permissões de pedido"
    }
  }, [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "",
      "columns": 12
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.permissionOrderSelected),
      expression: "permissionOrderSelected"
    }],
    staticClass: "form-select",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.permissionOrderSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.getPermissionOrder()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "notPermission"
    }
  }, [_vm._v("Sem permissão")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "readOnly"
    }
  }, [_vm._v("Somente leitura")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "readAndWriting"
    }
  }, [_vm._v("Leitura e escrita")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "advancedOptionsOrder"
    }
  }, [_vm._v("Opções avançadas")])])])], 1), _vm._v(" "), (_vm.permissionOrderSelected === 'advancedOptionsOrder') ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, _vm._l((_vm.orderAdvancedOptions), function(option) {
    return (option.resource !== '/service/status') ? _c('form-group', {
      key: option,
      attrs: {
        "label": option.resource,
        "columns": 4
      }
    }, _vm._l((Object.keys(option.actions)), function(action) {
      return _c('label', {
        staticClass: "form-checkbox"
      }, [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (option.actions[action]),
          expression: "option.actions[action]"
        }],
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": Array.isArray(option.actions[action]) ? _vm._i(option.actions[action], null) > -1 : (option.actions[action])
        },
        on: {
          "change": function($event) {
            var $$a = option.actions[action],
              $$el = $event.target,
              $$c = $$el.checked ? (true) : (false);
            if (Array.isArray($$a)) {
              var $$v = null,
                $$i = _vm._i($$a, $$v);
              if ($$el.checked) {
                $$i < 0 && (_vm.$set(option.actions, action, $$a.concat([$$v])))
              } else {
                $$i > -1 && (_vm.$set(option.actions, action, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
              }
            } else {
              _vm.$set(option.actions, action, $$c)
            }
          }
        }
      }), _vm._v(" "), _c('span', {
        staticClass: "form-checkbox__indicator"
      }), _vm._v(" "), _c('span', {
        staticClass: "form-checkbox__text"
      }, [_vm._v(_vm._s(action))])])
    }), 0) : _vm._e()
  }), 1)]) : _vm._e()]), _vm._v(" "), _c('panel', [_c('button', {
    staticClass: "btn btn--success",
    class: {
      'is-loading': _vm.saving
    },
    attrs: {
      "disabled": _vm.saving,
      "type": "submit"
    },
    on: {
      "click": function($event) {
        return _vm.save()
      }
    }
  }, [_vm._v("Salvar")])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f4151930","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Token/Edit.vue
// module id = 3491
// module chunks = 0